module.exports = "/img/buttonC.a7ccc6bb.png";